import React from 'react';
import { connect } from 'react-redux';
import { AppState, IPageState } from '../../appredux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import ResponsiveImgMaterialUi from 'responsive-img-material-ui';



interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
    open: boolean,
    closeDialog: () => void,
    zdjecie: any,
    tytul: string,
}

interface DialogState {
    //open: boolean
}

class DialogUkryjPracownika extends React.Component<DialogProps, DialogState>  {

    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            //open: false
        }
    }

    componentDidUpdate(prevProps: DialogProps) {
        //if(this.props.page.openDialogError !== prevProps.page.openDialogError){
        //    this.setState({open: true})
        //}
    }


    render() {
        const classes = this.props.classes;

        let tablet = this.props.page.tablet
       
        return (
            <>
                <Dialog
                    maxWidth="xs"
                    open={this.props.open}
                    onEscapeKeyDown={this.props.closeDialog}
                    onBackdropClick={this.props.closeDialog}
                    style={{zoom: tablet? "1.2" : "1"}}
                    fullWidth
                >
                    <DialogTitle disableTypography style={{padding: "16px 24px 0px 24px"}}>
                        <Typography gutterBottom variant="h6" component="h2" color='primary'
                            className={`${classes.headline}`}><b style={{ }}>{this.props.tytul}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent>
                        <div style={{
                            textAlign: 'center',
                        }}>

                            {/* maxWidth: "330px"*/}
                            <ResponsiveImgMaterialUi style={{ width: "100%", }}  
                                xs={this.props.zdjecie}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="primary" size="small" className={classes.button}
                            onClick={this.props.closeDialog}>
                            <b>wróć</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      error: {
          color: "rgb(244, 67, 54)"
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      paddingLeft: {
        paddingLeft: "20px"
      },
      headline: {
        lineHeight: "20px",
      },
      dialogContentText: {
        color: theme.palette.text.secondary,
        whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '12px'
      },
      button: {
        textTransform: "none" as "none"
    },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogUkryjPracownika));

